const module = {
  namespaced: true,
  state: {
    items: []
  },
  mutations: {
    beforeFetch: (state, { id, url, options }) => {
      state.items.push({
        id,
        url,
        options,
        response: undefined,
        payload: undefined,
        error: undefined
      });
    },
    onSuccess: (state, { id, response }) => {
      state.items = state.items.map(item => item.id === id ? { ...item, response } : item);
    },
    onPayload: (state, { id, payload }) => {
      state.items = state.items.map(item => item.id === id ? { ...item, payload } : item);
    },
    onError: (state, { id, error }) => {
      state.items = state.items.map(item => item.id === id ? { ...item, error } : item);
    }
  }
};

export default (store, router) => {
  console.log('adding debugger');
  store.registerModule('logger', module);
  router.addRoutes([{
    path: '/debug',
    name: 'debug',
    component: () => import('@/views/Debug/Index.vue')
  }]);
  const _fetch = fetch;
  window.fetch = (url, options) => {
    const id = new Date().getTime();
    store.commit('logger/beforeFetch', { id, url, options });

    const onRejected = error => {
      store.commit('logger/onError', { id, error });

      return Promise.reject(error);
    };
    return _fetch(url, options)
      .then(response => {
        store.commit('logger/onSuccess', { id, response });

        return {
          ...response,
          json () {
            return response.json()
              .then(payload => {
                store.commit('logger/onPayload', { id, payload });

                return payload;
              })
              .catch(onRejected)
          }
        };
      })
      .catch(onRejected);
  };
}
